import React, { FC } from 'react';
import { Action, Icon, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';
import { BuyerResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-response.dto';
import { ProjectOrganizationRelationType } from '../../../store/tradeAPI/projectSupporter/project-organization-relation-type';

interface LandscapeProjectsAddProjectsGeneralInformationLeadPartnersOrganismProps {
  data: BuyerResponseDto[];
  handleDelete: (id: string) => void;
  relationType: ProjectOrganizationRelationType;
}

const LandscapeProjectsAddProjectsGeneralInformationLeadPartnersOrganism: FC<
  LandscapeProjectsAddProjectsGeneralInformationLeadPartnersOrganismProps
> = ({ data, handleDelete, relationType }) => {
  return (
    <SortableTable
      data={data}
      columns={[
        { label: 'Supporter', key: 'name' },
        { label: 'Relation Type', key: 'profileType' },
        { label: 'Url', key: 'url' },
        { label: 'Logo', key: 'logo' },
      ]}
      renderRow={(row) => (
        <TableRow>
          <Label content={row.name ?? ''} />
          <Label content={relationType} />
          <Label content={row.url ?? ''} />
          <Icon imageUrl={row.logo ?? ''} shape="roundedCircle" size="xs" />
          <Action
            onClick={() => handleDelete(row.id)}
            type="delete"
            size="sm"
          />
        </TableRow>
      )}
      showEditButtonHeader={false}
    />
  );
};

export default LandscapeProjectsAddProjectsGeneralInformationLeadPartnersOrganism;
